import { nodeTypeFactory } from '../../../../utils/schema';
export const imageNodeName = 'image';
export const imageType = nodeTypeFactory(imageNodeName);
export const ImageAttr = {
    Src: 'src',
    Alt: 'alt',
    Title: 'title',
    Loading: 'loading',
};
export const ImageSpecs = (builder) => {
    builder.addNode(imageNodeName, () => ({
        spec: {
            inline: true,
            attrs: {
                [ImageAttr.Src]: {},
                [ImageAttr.Alt]: { default: null },
                [ImageAttr.Title]: { default: null },
                [ImageAttr.Loading]: { default: null },
            },
            group: 'inline',
            draggable: true,
            parseDOM: [
                {
                    tag: 'img[src]',
                    getAttrs(dom) {
                        return {
                            [ImageAttr.Src]: dom.getAttribute(ImageAttr.Src),
                            [ImageAttr.Alt]: dom.getAttribute(ImageAttr.Alt),
                            [ImageAttr.Title]: dom.getAttribute(ImageAttr.Title),
                            [ImageAttr.Loading]: dom.getAttribute(ImageAttr.Loading),
                        };
                    },
                },
            ],
            toDOM(node) {
                return ['img', node.attrs];
            },
        },
        fromYfm: {
            tokenSpec: {
                name: imageNodeName,
                type: 'node',
                getAttrs: (tok) => {
                    var _a, _b;
                    return ({
                        [ImageAttr.Src]: tok.attrGet('src'),
                        [ImageAttr.Title]: tok.attrGet('title') || null,
                        [ImageAttr.Loading]: tok.attrGet(ImageAttr.Loading) || null,
                        [ImageAttr.Alt]: ((_b = (_a = tok.children) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) || null,
                    });
                },
            },
        },
        toYfm: (state, { attrs }) => {
            state.write('![' +
                state.esc(attrs.alt || '') +
                '](' +
                state.esc(attrs.src) +
                (attrs.title ? ' ' + state.quote(attrs.title) : '') +
                ')');
        },
    }));
};
